import { render, staticRenderFns } from "./GEMANFTContent.vue?vue&type=template&id=4f1fb88f&scoped=true"
import script from "./GEMANFTContent.vue?vue&type=script&lang=js"
export * from "./GEMANFTContent.vue?vue&type=script&lang=js"
import style0 from "./GEMANFTContent.vue?vue&type=style&index=0&id=4f1fb88f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1fb88f",
  null
  
)

export default component.exports